import { FC, useMemo } from 'react'
import { DraftGpsDistribution, GpsDistributionGeoJson } from '../types/types'
import { generateGeoJsonUrl } from 'lib/helpers/gpsHelper'
import MintWindow from './MintWindow'

interface GpsDistributionProps {
  gps: DraftGpsDistribution
}

interface GpsData {
  lat: number
  lng: number
  radius: number
}

const getGpsData = (geoJson: GpsDistributionGeoJson | null): GpsData | null => {
  if (!geoJson?.features?.[0]?.geometry) return null
  const geometry = geoJson.features[0].geometry
  if (geometry.type !== 'Point') return null

  const [lng, lat] = geometry.coordinates
  const radius = geoJson.features[0].properties?.radius ?? null

  if (radius === null) return null

  return { lat, lng, radius }
}

const GpsDistribution: FC<GpsDistributionProps> = ({ gps }) => {
  const gpsData = getGpsData(gps.geoJson)

  const geojsonUrl = useMemo(() => {
    if (!gpsData) return null
    return generateGeoJsonUrl(gpsData.lat, gpsData.lng, gpsData.radius, 'Draft Location')
  }, [gpsData])

  return (
    <div>
      <h4>GPS Distribution</h4>
      {gpsData && (
        <>
          <p>
            <strong>Coordinates:</strong>{' '}
            {geojsonUrl ? (
              <a
                href={geojsonUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#007bff', textDecoration: 'underline' }}
              >
                {gpsData.lat.toFixed(6)}, {gpsData.lng.toFixed(6)}
              </a>
            ) : (
              `${gpsData.lat.toFixed(6)}, ${gpsData.lng.toFixed(6)}`
            )}
          </p>
          <p>
            <strong>Radius:</strong> {Math.round(gpsData.radius)} m
          </p>
        </>
      )}
      <MintWindow startDate={gps.startDate} endDate={gps.endDate} />
    </div>
  )
}

export default GpsDistribution
